module.exports = __webpack_public_path__ + "assets/img/block-left-afcbc81b.png";